import { useEffect, useState } from 'react';
import '../styles/Navigation.css';

const Navigation: React.FC = () => {
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    useEffect(() => {
      const onPopState = () => setCurrentPath(window.location.pathname);
      window.addEventListener('popstate', onPopState);
      return () => window.removeEventListener('popstate', onPopState);
    }, []);

    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
      if (window.location.pathname !== href) {
        e.preventDefault();
        window.history.pushState({}, '', href);
        setCurrentPath(href);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    };

    return (
      <nav>
        <a
          href="/"
          className="nav-link"
          onClick={e => handleNavClick(e, '/')}
        >
          Home
          <span
            style={{
              marginLeft: 10,
              fontSize: 16,
              color: (currentPath === '/' || currentPath === '/index.html') ? '#1976d2' : '#888',
              transition: 'transform 0.2s',
              display: 'inline-block',
              verticalAlign: 'middle',
              transform: (currentPath === '/' || currentPath === '/index.html') ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
            aria-label={currentPath === '/' || currentPath === '/index.html' ? 'Current page' : 'Navigate'}
            title={currentPath === '/' || currentPath === '/index.html' ? 'Current page' : 'Navigate'}
          >
            ▶
          </span>
        </a>
        <a
          href="/services"
          className="nav-link"
          onClick={e => handleNavClick(e, '/services')}
        >
          Services
          <span
            style={{
              marginLeft: 10,
              fontSize: 16,
              color: currentPath === '/services' ? '#1976d2' : '#888',
              transition: 'transform 0.2s',
              display: 'inline-block',
              verticalAlign: 'middle',
              transform: currentPath === '/services' ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
            aria-label={currentPath === '/services' ? 'Current page' : 'Navigate'}
            title={currentPath === '/services' ? 'Current page' : 'Navigate'}
          >
            ▶
          </span>
        </a>
        {/* Add more navigation links here as needed */}
      </nav>
    );
}

export default Navigation;
